/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpToDoubleLine: {
  name: 'arrow-up-to-double-line';
  data: string;
} = {
  name: 'arrow-up-to-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 1A.5.5 0 0 1 3 .5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5ZM8 15.5a.5.5 0 0 0 .5-.5V6.207l4.146 4.147a.5.5 0 0 0 .708-.708l-5-5A.498.498 0 0 0 8 4.5h5a.5.5 0 0 0 0-1H3a.5.5 0 0 0 0 1h5a.498.498 0 0 0-.354.146l-5 5a.5.5 0 0 0 .708.708L7.5 6.207V15a.5.5 0 0 0 .5.5Z" fill="currentColor"/></svg>`,
};
